import { useOnClickOutside } from "./useOnClickOutside";

export default useOnClickOutside;
